import React from 'react';//, { useState }
import { webData } from './../../../const';
import './allProjekts.sass';

export const AllProjectsWeb = ( ) => {

    return(
        <>
            {webData.map((item:{web: string, name: string, altName: string, imgName: any}, index: number) =>{
                
                return(
                    <a key={index} href={item.web} rel="noopener noreferrer" target="_blank" id='allProjectsA' >
                        <div key={index} className="All_projects_blocks adaptivnost_otstupov"> 
                            <img src={item.imgName} alt={item.altName} id="all_projects_img_blocks" />
                            <div className="AllProjektsText" >{item.name}</div>
                        </div>
                    </a>
                )
            })}
        </>  
    )
}